/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { startCase } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withNamespaces } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';
import AppUrls from '../../config/AppUrls';
import { getMerchantDetails } from '../../redux/reducers/MerchantsReducer';
import RoundedTitle from '../common/RoundedTitle';
import AvatarSelector from '../common/AvatarSelector';
import PersonalInfoArea from './PersonalInfoArea';
import SecurityInfoArea from './SecurityInfoArea';
import ChangePasswordArea from './ChangePasswordArea';
import AccountsService from '../../services/AccountsService';
import { showSuccess, showError } from '../../redux/actions/GlobalToastActions';
import Loading from '../common/Loading';
import ChangeMfaArea from './ChangeMfaArea';
import EnterMfaCodeArea from './EnterMfaCodeArea';
import { getIdMerchant, getMultiMerchantList, getUser, idUser, isAdmin, isInternalUser, isMultiMerchant } from '../../redux/reducers/AuthReducer';
import { logout, updateLocalUserData } from '../../redux/actions/AuthActions';
import { hideModal } from '../../redux/actions/GlobalModalActions';
import { translate } from '../../utils/Formatters/LabelValueFormatters';
import { companyName } from '../../utils/Constants';
import SwitchContextArea from './SwitchContextArea';
import { modifyLanguage } from '../../config/i18n';
import config from '../../envConfig/config';
import { isTupayPanel } from '../../utils/panelUtils';

const PageStates = {
  Loading: 'loading',
  Waiting: 'waiting',
  EditingPassword: 'editing-password',
  EditingMfa: 'editing-mfa',
  EditingPersonalInfo: 'editing-personal-info',
  EditingSecurityInfo: 'editing-security-info',
  EditingImage: 'editing-image',
  SwitchContext: 'switch-context',
  EnterMfaCode: 'enter-mfa-code',
};

class EditProfileModal extends React.Component {
  state = {
    pageState: PageStates.Waiting,
    profileDetails: {
      photo: '',
    },
    personalInfo: {
      name: '',
      phoneNumber: '',
      language: '',
    },
    passwordInfo: {
      old: '',
      new: '',
      confirm: '',
      mfaCode: '',
    },
    securityInfo: {},
    mfaCode: '',
  };

  componentDidMount() {
    this.fetchAccountDetails();
  }

  fetchAccountDetails = async () => {
    this.setState({ isBusy: true });
    const { showError, idUser, t, updateLocalUserData } = this.props;
    try {
      const profileDetails = await AccountsService.fetchAccountDetails(idUser);
      this.setState({
        profileDetails,
        personalInfo: {
          name: profileDetails.name,
          phoneNumber: profileDetails.phoneNumber,
          language: profileDetails.language,
        },
      });
      updateLocalUserData(profileDetails);
    } catch (err) {
      showError(t('errorFetchProfile'));
    } finally {
      this.setState({ isBusy: false });
    }
  };

  /** Avatar */

  saveAvatar = async (base64Image) => {
    const { idUser, showSuccess, showError, t } = this.props;
    this.setState({ isAvatarLoading: true });
    try {
      await AccountsService.addAccountPhoto(idUser, base64Image);
      await this.fetchAccountDetails();
      this.setState({ pageState: PageStates.Waiting });
      showSuccess(t('labelAvatarUploadSuccessful'));
    } catch (err) {
      showError(t('errorAvatarUpload'));
    } finally {
      this.setState({ isAvatarLoading: false, pageState: PageStates.Waiting });
    }
  };

  /** Personal Info */

  handleSavePersonalInfo = (personalInfo) => {
    this.setState({
      personalInfo,
    });
    this.savePersonalInfo();
  };

  startEditingPersonalInfo = () => {
    this.setState({ pageState: PageStates.EditingPersonalInfo });
  };

  savePersonalInfo = async () => {
    this.setState({ isBusy: true });
    const { personalInfo } = this.state;
    const { idUser, showSuccess, showError, t } = this.props;
    try {
      await AccountsService.updateProfile(idUser, personalInfo);
      await this.fetchAccountDetails();
      modifyLanguage(personalInfo.language);
      this.setState({ pageState: PageStates.Waiting });
      showSuccess(t('successEditProfile'));
    } catch (err) {
      showError(t('errorEditProfile'));
    }
    this.setState({ isBusy: false });
  };

  /** Security Info */

  handleSecurityHeaderClick = () => {
    const { pageState } = this.state;
    if (pageState === PageStates.EditingSecurityInfo) {
      this.finishEditingSecurity();
    } else {
      this.startEditingSecurityInfo();
    }
  };

  startEditingSecurityInfo = () => {
    this.setState({ pageState: PageStates.EditingSecurityInfo });
  };

  finishEditingSecurity = () => {
    this.setState({ pageState: PageStates.Waiting });
  };

  /** Password Change */

  handleSubmitPassword = (passwordInfo) => {
    this.setState({ passwordInfo });
    this.saveChangePassword();
  };

  handleSubmitMFA = (passwordInfo) => {
    this.setState({ passwordInfo });
    this.saveChanePasswordWithMFA();
  };

  saveChanePasswordWithMFA = async () => {
    const { idUser, showSuccess, showError, t } = this.props;
    const {
      passwordInfo: { old: oldPassword, new: password, confirm: confirmPassword, mfaCode },
    } = this.state;
    try {
      await AccountsService.changePassword(idUser, { oldPassword, password, confirmPassword, mfaCode });
      showSuccess(t('messagePasswordChanged'));
      this.setState({ pageState: PageStates.Waiting, passwordInfo: { old: '', new: '', confirm: '' } });
    } catch (err) {
      this.showErrorOnChangePassword(err, showError);
    } finally {
      this.setState({ isBusy: false });
    }
  };

  saveChangePassword = async () => {
    this.setState({ isBusy: true });
    const { idUser, showSuccess, showError, t } = this.props;
    const {
      passwordInfo: { old: oldPassword, new: password, confirm: confirmPassword },
      profileDetails,
    } = this.state;
    try {
      await AccountsService.changePassword(idUser, { oldPassword, password, confirmPassword });
      if (profileDetails.mfaEnabled === false) {
        showSuccess(t('messagePasswordChanged'));
        this.setState({ pageState: PageStates.Waiting, passwordInfo: { old: '', new: '', confirm: '' } });
      } else {
        // ask the mfa code.
        this.setState({ pageState: PageStates.EnterMfaCode, passwordInfo: { old: oldPassword, new: password, confirm: confirmPassword, mfaCode: '' } });
      }
    } catch (err) {
      this.showErrorOnChangePassword(err, showError);
    } finally {
      this.setState({ isBusy: false });
    }
  };

  onChangePasswordClick = () => {
    this.setState({ pageState: PageStates.EditingPassword });
  };

  /** MFA */

  onEnableMfaClick = async () => {
    await this.getMfaImage();
    this.setState({ pageState: PageStates.EditingMfa });
  };

  onDisableMfaClick = () => {
    this.setState({ pageState: PageStates.EditingMfa });
  };

  onMfaChange = (mfaCode) => {
    this.setState({ mfaCode });
  };

  getMfaImage = async () => {
    const { showError, t, idUser } = this.props;
    this.setState({ isBusy: true });
    try {
      const mfaImage = await AccountsService.getMfaImage(idUser);
      this.setState({ mfaImage });
    } catch (err) {
      showError(t('errorEnableMfa'));
    } finally {
      this.setState({ isBusy: false });
    }
  };

  onConfirmMfa = async () => {
    const { idUser, showError, showSuccess, t } = this.props;
    const {
      mfaCode,
      profileDetails: { mfaEnabled: currentMfaEnabled },
    } = this.state;
    const method = currentMfaEnabled ? AccountsService.disableMfa : AccountsService.enableMfa;
    this.setState({ isBusy: true });
    try {
      await method(idUser, mfaCode);
      await this.fetchAccountDetails();
      this.setState({ pageState: PageStates.Waiting, mfaCode: 0 });
      showSuccess(t('messageMfaChanged'));
    } catch (err) {
      showError(t('errorChangeMfa'));
    } finally {
      this.setState({ isBusy: false });
    }
  };

  /** Generic */

  cancelCurrentEdition = () => {
    this.setState({ pageState: PageStates.Waiting, passwordInfo: { old: '', new: '', confirm: '' }, mfaCode: 0 });
  };

  handleLogout = (event) => {
    const { logout, hideModal } = this.props;
    event.preventDefault();
    hideModal();
    logout();
  };

  handleSwitch = () => {
    this.setState({ pageState: PageStates.SwitchContext });
  };

  renderCompanyImg = () => {
    const { isInternalUser, merchantDetails } = this.props;
    const { REACT_APP_LOGO_URL = {} } = config || {};
    const { companyImg = 'directa-new-logo-crop_143.png' } = REACT_APP_LOGO_URL;
    const baseClassName = 'profile-info';
    const companyNameClassName = isTupayPanel ? baseClassName : `${baseClassName} internal`;

    if (isInternalUser) {
      return <img src={`${AppUrls.resources.logos}${companyImg}`} alt={companyName} className={companyNameClassName} />;
    }
    const { profileDetails, errorLogo } = this.state;
    if (profileDetails.merchantPhoto && !errorLogo) {
      return (
        <img
          src={profileDetails.merchantPhoto}
          alt={merchantDetails.name && merchantDetails.name[0]}
          className="profile-info"
          onError={() => this.setState({ errorLogo: true })}
          onLoad={() => this.setState({ errorLogo: false })}
        />
      );
    }
    return (
      <span className="letter" style={{ textTransform: 'uppercase' }}>
        {merchantDetails.name ? merchantDetails.name[0] : 'M'}
      </span>
    );
  };

  showErrorOnChangePassword(err, showError) {
    const {
      response: {
        data: { description = '' },
      },
    } = err;
    const msgError = description || 'labelNetworkError';
    showError(msgError);
  }

  render() {
    const { showError, t, hideModal, storedUser, isAdmin, isInternalUser, merchantDetails, isMultiMerchant, multiMerchantList, idMerchant } = this.props;
    const { profileDetails, mfaCode, securityInfo, personalInfo, passwordInfo, pageState, isAvatarLoading, isBusy, mfaImage } = this.state;
    const { photo } = profileDetails;
    const name = isInternalUser ? companyName : merchantDetails.name;
    const legalName = isInternalUser ? '' : merchantDetails.legalName;
    return (
      <div className="edit-profile-modal">
        {isBusy ? <Loading /> : null}
        <div className="close-action">
          <FontAwesomeIcon
            icon={faTimes}
            onClick={() => {
              hideModal();
            }}
          />
        </div>
        {/* LEFT AREA */}
        <div className="edit-profile-modal__left">
          <div className="top-area">
            <AvatarSelector
              isLoading={isAvatarLoading}
              image={photo}
              onSelectImage={this.saveAvatar}
              onError={showError}
              t={t}
              letter={profileDetails.name && profileDetails.name[0]}
              onStartEditing={() => this.setState({ pageState: PageStates.EditingImage })}
            />
            <div className="name-wrapper">
              {PageStates.EditingImage !== pageState ? <span>{startCase(profileDetails.name)}</span> : null}
              {storedUser.authorization.roles.map((role) => (
                <div key={role}>
                  <RoundedTitle title={translate(t, role)} style={{ backgroundColor: '#e8e8e8' }} />
                </div>
              ))}
            </div>
          </div>
          {isMultiMerchant && (
            <div className="switch-area">
              <button type="button" className="btn btn-dark" onClick={this.handleSwitch}>
                {t('labelSwitchAccount')}
              </button>
            </div>
          )}
          <div className="logout-area">
            <button type="button" className="btn btn-outline-secondary" onClick={this.handleLogout}>
              {t('labelLogout')}
            </button>
          </div>
        </div>
        {/* LEFT AREA */}
        {/* RIGHT AREA */}
        <div className="edit-profile-modal__right">
          <div className="edit-profile-modal__right__header">
            <div className="letter-wrapper">{this.renderCompanyImg()}</div>
            <div className="name-wrapper">
              <span className="merchant-name">{startCase(name)}</span>
              <span className="product-name">{startCase(legalName)}</span>
            </div>
          </div>
          <div className="edit-profile-modal__right__content">
            {/* EDIT AREA */}
            {[PageStates.Waiting, PageStates.EditingPersonalInfo, PageStates.EditingSecurityInfo].some((a) => a === pageState) ? (
              <div className="edit-area">
                <PersonalInfoArea t={t} onChange={this.onPersonalInfoChange} personalInfo={personalInfo} onSubmit={this.handleSavePersonalInfo} />
                <SecurityInfoArea
                  t={t}
                  isEditingSecurity={pageState === PageStates.EditingSecurityInfo}
                  mfaEnabled={profileDetails.mfaEnabled}
                  onSecurityInfoHeaderClick={this.handleSecurityHeaderClick}
                  onChangePasswordClick={this.onChangePasswordClick}
                  onEnableMfaClick={this.onEnableMfaClick}
                  passwordInfo={passwordInfo}
                  isAdmin={isAdmin}
                />
              </div>
            ) : null}
            {[PageStates.EditingPassword].some((a) => a === pageState) ? (
              <div className="edit-area">
                <ChangePasswordArea
                  t={t}
                  passwordInfo={passwordInfo}
                  securityInfo={securityInfo}
                  onCancel={this.cancelCurrentEdition}
                  onSubmit={this.handleSubmitPassword}
                  enterMfaCode={false}
                />
              </div>
            ) : null}
            {[PageStates.EditingMfa].some((a) => a === pageState) ? (
              <div className="edit-area">
                <ChangeMfaArea
                  t={t}
                  mfaCode={mfaCode}
                  mfaEnabled={profileDetails.mfaEnabled}
                  onCancel={this.cancelCurrentEdition}
                  onConfirm={this.onConfirmMfa}
                  onStartEnabling={this.getMfaImage}
                  onChange={this.onMfaChange}
                  mfaImage={mfaImage}
                />
              </div>
            ) : null}
            {[PageStates.SwitchContext].some((a) => a === pageState) ? (
              <div className="edit-area">
                <SwitchContextArea
                  t={t}
                  accountList={multiMerchantList.filter((m) => m.key !== idMerchant)}
                  mfaEnabled={profileDetails.mfaEnabled}
                  onCancel={this.cancelCurrentEdition}
                />
              </div>
            ) : null}
            {[PageStates.EnterMfaCode].some((a) => a === pageState) ? (
              <div className="edit-area">
                <EnterMfaCodeArea t={t} passwordInfo={passwordInfo} onCancel={this.cancelCurrentEdition} onSubmit={this.handleSubmitMFA} enterMfaCode />
              </div>
            ) : null}
            <div className="footer-area">
              <button type="button" className="btn btn-outline-secondary">
                {t('labelSave')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    idUser: idUser(state),
    storedUser: getUser(state),
    isAdmin: isAdmin(state),
    isInternalUser: isInternalUser(state),
    merchantDetails: getMerchantDetails(state),
    isMultiMerchant: isMultiMerchant(state),
    multiMerchantList: getMultiMerchantList(state),
    idMerchant: getIdMerchant(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      hideModal,
      logout,
      showSuccess,
      showError,
      updateLocalUserData,
    },
    dispatch
  );

export default compose(withNamespaces(), connect(mapStateToProps, mapDispatchToProps))(EditProfileModal);
